
import React ,{ useState}  from "react";
import swal from "sweetalert";
import firebase from "./Config";

const Contact = (props) => {
    var today = new Date();

    var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    
    var time1 = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    
    var dateTime = date+' '+time1;
    const [name, setName] = useState("");
    const [Email, setEmail] = useState("");
    const [Message, setMessage] = useState(""); 
    const [isBusy, setIsBusy] = useState(false);
    const [routeRedirect, setRedirect] = useState(false);   
    const addPost = async(e) => {
        e.preventDefault();
        setIsBusy(true);

        let post = {
            name, 
            Email,
            Message,
            datatime:dateTime
        }

        await firebase.createContact(post).then(() => {
           
            setIsBusy(false);
            swal("Your Message Sent","Sent","success");
            setRedirect(true);
        
        }).catch(err => {
            console.log(err);
            setIsBusy(false);
        })        

        }



        
     
    
    
        
    

    return ( 
      <section id="it-up-contact " class="it-up-contact-section position-relative">
		<span class="it-up-service-shape position-absolute deco1">
			<img src="s-shape1.png" alt=""/></span>
		<span class="it-up-service-shape position-absolute deco2">
			<img src="s-shape2.png" alt=""/></span>
		<span class="it-up-service-shape position-absolute deco3">
			<img src="s-shape3.png" alt=""/></span>
		<span class="it-up-service-shape position-absolute deco4">
			<img src="s-shape4.png" alt=""/></span>
		<span class="it-up-service-shape position-absolute deco5">
			<img src="s-shape5.png" alt=""/></span>
		<div class="container" id="contact">
			<div class="it-up-section-title-2 headline-1 text-center">
				<span>_Let’s Work with us_</span>
				<h2>If you want to work please
				contact with us! </h2>
			</div>
			<div class="it-up-contact-content">
				<div class="row">
					<div class="col-lg-5">
						<div class="it-up-contact-img position-relative">
							<img src="cn-bg.jpg" alt=""/>
							<span class="contact-shape position-absolute" data-parallax="{&quot;y&quot; : -50}" style={{transform:"translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1)", WebkitTransform:"translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1)"}}>
								<img src="cn-sh1.png" alt=""/></span>
							<div class="it-up-contact-text text-center headline-1">
								<img src="marker.png" alt=""/>
								<h4>Main Sheikhupura Road near NTU, Faisalabad.</h4>
							</div>
						</div>
					</div>
					<div class="col-lg-7">
						<div class="it-up-form-wrap">
							<form onSubmit={addPost}>
								<div class="it-up-form-input">
									<div class="row">
										<div class="col-md-6">
											<label>Full name*</label>
											<input type="text" placeholder="Jhon Doe"name="name" onChange={(e) => setName(e.target.value)} required/>
										</div>
										<div class="col-md-6">
											<label>Mail address*</label>
											<input type="text" placeholder="email@example.com" name="Email" onChange={(e) => setEmail(e.target.value)}  required/>
										</div>
									</div>
								</div>
							
								<div class="it-up-form-input">
									<label>Type your message*</label>
									<textarea placeholder="Message..." required name="Message"  onChange={(e) => setMessage(e.target.value)}></textarea>
								</div>
								<button type="submit">Send your message <i class="fas fa-arrow-right"></i></button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>	

 
     );
}
 
export default Contact;